import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { KpiCard, ToggleBarChart, DonutBreakdownCard, SessionEventsDrawer } from '../../../common/analytics';
import { USAGE_KPI_ICONS, ADVANCE_SUMMARY_TOGGLES } from '../../dashboard.constants';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/usage-section.module.scss';

function UsageSection({ kpis = [], advanceSummary, advancesByType, bottomKpis = [], sessions = {}, loading = false }) {
    const sessionsClick = (kpi) =>
        kpi.key === 'totalSessions' && sessions.onOpen ? () => sessions.onOpen() : undefined;

    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Usage</Text>

            {loading ? (
                <>
                    <div className={styles.kpiRow}>
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                    </div>
                    <div className={styles.splitRow}>
                        <CardSkeleton minHeight={420} rows={6} />
                        <CardSkeleton minHeight={420} rows={6} />
                    </div>
                    <div className={styles.kpiRowFour}>
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                    </div>
                </>
            ) : (
                <>
            <div className={styles.kpiRow}>
                {kpis.map((kpi) => (
                    <KpiCard
                        key={kpi.key}
                        label={kpi.label}
                        value={kpi.value}
                        variant={kpi.variant}
                        conversionRate={kpi.conversionRate}
                        icon={USAGE_KPI_ICONS[kpi.key]}
                        isCurrency={kpi.isCurrency}
                        onClick={sessionsClick(kpi)}
                    />
                ))}
            </div>

            <div className={styles.splitRow}>
                <ToggleBarChart
                    title={advanceSummary.title}
                    subtitle={advanceSummary.subtitle}
                    toggles={ADVANCE_SUMMARY_TOGGLES}
                    defaultToggle="volume"
                    series={advanceSummary.series}
                    data={advanceSummary.data}
                    showLegend={false}
                />
                <DonutBreakdownCard
                    title={advancesByType.title}
                    subtitle={advancesByType.subtitle}
                    total={advancesByType.total}
                    totalLabel={advancesByType.totalLabel}
                    segments={advancesByType.segments}
                />
            </div>

            <div className={styles.kpiRowFour}>
                {bottomKpis.map((kpi) => (
                    <KpiCard
                        key={kpi.key}
                        label={kpi.label}
                        value={kpi.value}
                        variant={kpi.variant}
                        conversionRate={kpi.conversionRate}
                        icon={USAGE_KPI_ICONS[kpi.key]}
                        isCurrency={kpi.isCurrency}
                        onClick={sessionsClick(kpi)}
                    />
                ))}
            </div>
                </>
            )}

            <SessionEventsDrawer sessions={sessions} />
        </section>
    );
}

export default UsageSection;
